import {HeaderTitle} from '@/components/atoms'
import {Header as HeaderConst} from '@/utils/constants/header'
import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import {useDeliveryAndStatusInfo} from './DeliveryAndStatusInfo-hook'

export const DeliveryAndStatusInfo = ({deliveryAndStausInfo}) => {
  const {deliveryAndStatusInfoJsonSchema, deliveryAndStatusInfoUISchema} = useDeliveryAndStatusInfo()
  const getVal = v => v || '-'
  return (
    <div className="mt-6">
      <HeaderTitle
        title="Delivery and Status Information"
        headingLevel={HeaderConst.SectionTitle}
        className="sectionTitle pl-4 pr-4"
      />
      <div className="divider mb-5 mt-5" />
      <div className="pl-4 pr-4">
        <JsonFormsWrapper
          jsonschema={deliveryAndStatusInfoJsonSchema}
          uischema={deliveryAndStatusInfoUISchema}
          data={{
            deliveryMethod: getVal(deliveryAndStausInfo?.deliveryMethod),
            digitalAddress: getVal(deliveryAndStausInfo?.digitalAddress),
            deposit: getVal(deliveryAndStausInfo?.deposit),
            depositWithLineItem: getVal(deliveryAndStausInfo?.depositWithLineItem),
            removedStatus: getVal(deliveryAndStausInfo?.removedStatus),
            additionalItemStatus: getVal(deliveryAndStausInfo?.additionalItemStatus),
            notDeliveryItem: getVal(deliveryAndStausInfo?.notDeliveryItem),
            replacementProduct: getVal(deliveryAndStausInfo?.replacementProduct),
          }}
        />
      </div>
    </div>
  )
}
